import { connect } from 'react-redux'
import { IStoreState, IMobilityOptionObject, IAssistanceObject } from '../../types/index'
import { removeMobilityOption } from 'src/state/actions/mobility-options'
import RemoveAssistanceModal from 'src/components/global-settings/RemoveAssistanceModal'
import { removeAssistance } from 'src/state/actions/assistance'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    assistances: state.assistances.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    remove: (assistance: IAssistanceObject) => {
      return dispatch(removeAssistance(assistance))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveAssistanceModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/RemoveAssistanceModal.ts